import axios from "../api/axiosInstance";

export const updateLeadStatus = async (leadId, newStatus) => {
  try {
    const response = await axios.post("/leadStatus", {
      id: leadId,
      status: newStatus,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating lead status:", error);
    throw error;
  }
};
